import React from 'react';
import type { CouncilCost, EventLogEntry } from '../../../../../types/council';
import { depthDistribution } from '../cockpitDerive';

export const CostTab: React.FC<{ cost?: CouncilCost | null; entries: EventLogEntry[]; darkMode: boolean }> =
({ cost, entries, darkMode }) => {
  const dist = Array.from(depthDistribution(entries).entries()).sort((a, b) => a[0] - b[0]);
  const max = dist.reduce((m, [, n]) => Math.max(m, n), 1);
  return (
    <div className="flex flex-col gap-2 px-3 py-2 text-[11px]">
      <div className="grid grid-cols-2 gap-y-0.5 tabular-nums">
        <span className="opacity-60">used</span><span>${cost?.cost_used_usd ?? '—'}</span>
        <span className="opacity-60">cap/day</span><span>${cost?.cost_cap_usd_per_day ?? '—'}</span>
        <span className="opacity-60">breaches</span><span>{cost?.overshoot_events?.length ?? 0}</span>
      </div>
      <div>
        <div className="opacity-60 mb-1">recursion depth distribution</div>
        <div className="flex items-end gap-1 h-10">
          {dist.length === 0 && <span className="opacity-40">no turns yet</span>}
          {dist.map(([d, n]) => (
            <div key={d} className="flex flex-col items-center gap-0.5">
              <span className={`w-4 rounded-t ${darkMode ? 'bg-emerald-600' : 'bg-emerald-400'}`}
                style={{ height: `${(n / max) * 32}px` }} />
              <span className="opacity-60">{d}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
